export default {
    header: {
        searchPlaceholder: 'Search…',
        getPro: 'Get Pro',
    },
    dashboard: 'Dashboard',
    modules: {
        sales: 'Sales',
        noc: 'NOC',
        finance: 'Finance',
        admin: 'Administration',
        hotspot: 'Hotspot',
    },
    branches: 'Branches',
    hotspotCustomers: 'Hotspot customers',
    htsCustomers: 'Hotspot customers',
    hotspotParents: 'Hotspot customers',
    hotspotCreatePackage: 'Create package',
    hotspotAllowances: 'HPS Customer allowances',
    customers: 'Customers',
    tasks: 'Tasks',
    installationForm: 'Installation Form',
    sales: {
        main: 'Sales',
        findCustomer: 'Find Customer',
        installationsList: 'Installation List',
        addCustomer: 'Add Customer',
        offlineCustomers: 'Offline Customers',
        resellers: 'Resellers'
    },
    equipment: 'Equipment',
    billing: 'Billing',
    serviceDiscounts: 'Service Discounts',
    taskAssignment: 'Task Assignment',
    installations: 'Installations',
    users: 'Users',
    settings: 'Settings',
    quickbooksAdmin: 'QuickBooks',
    qboSyncReview: 'QBO Sync Review',
    qboSyncReviewV2: 'QBO Sync Review V2',
    qboAccounts: 'QuickBooks Accounts',
    quickbooksAccounts: 'QuickBooks Accounts',
    cashSettings: 'Cash & Accounts Settings',
    cashBooks: 'Cash Books',
    quickbooks: {
        main: 'QuickBooks',
        admin: 'QuickBooks Admin',
        syncReview: 'QBO Sync Review'
    },
    language: 'Select Language',
    logout: 'Logout',
        payments: {
        main: 'Payments',
        cashLedger: 'Cash Ledger',
        cashBooks: 'Cash Books',
        cashBoxes: 'Cash Boxes',
        payment: 'Payment',
        list: 'Payments List',
        queue: 'Payments Queue',
        hotspot: 'Hotspot Payments'
    },
    invoices: {
        main: 'Invoices',
        search: 'Search Invoices',
        list: 'Invoices List'
    }
} 